import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-navy" data-id="element-38">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-39">
        <FadeIn data-id="element-40">
          <div className="bg-navy-light border border-gold/20 rounded-3xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-center gap-6 text-center md:text-left" data-id="element-41">
            <div className="w-24 h-24 rounded-full bg-gold/15 flex items-center justify-center flex-shrink-0 border border-gold/30" data-id="element-42">
              <ShieldCheck className="w-12 h-12 text-gold" data-id="element-43" />
            </div>
            <div data-id="element-44">
              <h2 className="text-2xl md:text-3xl font-black text-beige mb-3" data-id="element-45">
                7 días de <span className="text-gold" data-id="element-46">garantía total</span>
              </h2>
              <p className="text-lg text-beige/70 max-w-xl" data-id="element-47">
                Probá Piano Fácil PRO sin riesgo. Si no te convence o sentís que
                no es para vos, te devolvemos el 100% de tu dinero. Sin
                preguntas.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}